import httpClient, { ConexaResponse } from '@/services/httpClient'

export class ChatService {
  static async getChatToken() {
    const { data } = await httpClient.get<ConexaResponse<string>>(
      '/talkjs/patient-token',
    )

    return data.object
  }

  static async patientHasNearbyAppointments() {
    const { data } = await httpClient.get<ConexaResponse<boolean>>(
      '/talkjs/patient-has-nearby-appointments',
    )

    return data.object
  }
}
